import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Report } from './report.model';
import { ReportParams } from './report-params.model';
import { ReportFavoriteParams } from './favorite-params.model';

export const reportFavorite = createAction(
    '[Report/API] Report Favorite',
    props<{ report: ReportFavoriteParams }>()
);

export const loadReports = createAction(
    '[Report/API] Load Reports',
    props<{ reports: Report[] }>()
);

export const addReport = createAction(
    '[Report/API] Add Report',
    props<{ report: Report }>()
);

export const upsertReport = createAction(
    '[Report/API] Upsert Report',
    props<{ report: Report }>()
);

export const addReports = createAction(
    '[Report/API] Add Reports',
    props<{ reports: Report[] }>()
);

export const upsertReports = createAction(
    '[Report/API] Upsert Reports',
    props<{ reports: Report[] }>()
);

export const updateReport = createAction(
    '[Report/API] Update Report',
    props<{ report: Update<Report> }>()
);

export const updateReports = createAction(
    '[Report/API] Update Reports',
    props<{ reports: Update<Report>[] }>()
);

export const deleteReport = createAction(
    '[Report/API] Delete Report',
    props<{ id: string }>()
);

export const deleteReports = createAction(
    '[Report/API] Delete Reports',
    props<{ ids: string[] }>()
);

export const clearReports = createAction('[Report/API] Clear Reports');

export const getReports = createAction(
    '[Report/API] Get Reports',
    props<{ EmployeeListID: string }>()
);
export const setReportParams = createAction(
    '[Report/API] Set Report Params',
    props<{ params: ReportParams }>()
);

export const runReport = createAction(
    '[Report/API] Run Report',
    props<{
        report: {
            report: Report;
            params: ReportParams;
            queryparams: any;
        };
    }>()
);
export const setPopupBlocker = createAction(
    '[Report/API] Set Popup Blocker',
    props<{ value: boolean }>()
);
